package ui.app.assign.detail.definition

import androidx.compose.animation.*
import androidx.compose.animation.core.*
import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.draw.*
import androidx.compose.ui.graphics.*
import androidx.compose.ui.text.style.*
import androidx.compose.ui.unit.*
import compose.assets.*
import compose.assets.svg.*
import org.burnoutcrew.reorderable.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tools.*
import ui.app.assign.detail.*
import ui.widget.*

@Composable
fun AppDetailScope.AppDefOfAppsGroupConfig(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfAppGroup
) {
    if (display.isMobile) {
        Column {
            DefaultFields(
                nnvl = wrapper,
                modifier = Modifier.fillMaxWidth(),
                mainContent = { MainContent(wrapper, nnvl, Modifier.fillMaxWidth()) },
                secondaryContent = { SecondaryContent(wrapper, nnvl, Modifier.fillMaxWidth()) },
            )
        }
    } else {
        Column {
            DefaultFields(
                nnvl = wrapper,
                modifier = Modifier.fillMaxWidth(),
                mainContent = { MainContent(wrapper, nnvl, Modifier.fillMaxWidth()) },
                secondaryContent = { SecondaryContent(wrapper, nnvl, Modifier.fillMaxWidth()) })
        }
    }
}

@Composable
fun AppDetailScope.SecondaryContent(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfAppGroup,
    modifier: Modifier
) {
    Column(modifier) {
        FieldTextString(
            canEdit = wrapper.canEdit,
            icon = Svg.Search,
            label = Res.string.layer_bottom_editor__app_group_label_search,
            field = nnvl.labelSearch,
        )
    }
    Space(8.dp)
}

@Composable
fun AppDetailScope.MainContent(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfAppGroup,
    modifier: Modifier
) {
    Card(colors = CardDefaults.cardColors(MaterialTheme.colorScheme.inverseSurface)) {
        Row(modifier
            .clip(CardDefaults.shape)
            .clickable(wrapper.canEdit) { nnvl.showImages.set(!nnvl.showImages.state) }
            .padding(8.dp)) {
            Icon(
                imageVector = Svg.Image,
                contentDescription = null,
                modifier = Modifier.align(Alignment.CenterVertically)
            )
            Space(8.dp)
            Text(
                text = Res.string.layer_bottom_editor__show_images_label_search.rememberString(),
                modifier = Modifier
                    .weight(1F)
                    .align(Alignment.CenterVertically)
            )
            Space(8.dp)
            IconicSwitch(
                checked = nnvl.showImages.state,
                onCheckedChange = { nnvl.showImages.set(it) },
                modifier = Modifier.align(Alignment.CenterVertically)
            )
        }
    }

    Space(8.dp)
}


@Composable
fun AppDetailScope.AppDefOfAppsGroupApps(
    nnvl: AppDetailScope.WrapperDefinition.OfAppGroup
) {

    val reorderState = rememberReorderableLazyListState(
        onMove = { from, to -> nnvl.apps.swapOrder(from.index, to.index) },
        canDragOver = { _, _ -> true })

    Column(Modifier.fillMaxSize()) {
        LazyColumn(
            state = reorderState.listState,
            verticalArrangement = Arrangement.spacedBy(8.dp),
            contentPadding = PaddingValues(16.dp),
            modifier = Modifier.fillMaxSize().reorderable(reorderState)
        ) {
            itemsIndexed(
                items = nnvl.apps.state,
                key = { _, it -> it.key },
            ) { index, item ->

                ReorderableItem(
                    reorderableState = reorderState,
                    key = item.key,
                    index = index
                ) { isDragging ->

                    val elevation = animateDpAsState(if (isDragging) 8.dp else 0.dp)

                    val color = animateColorAsState(
                        if (isDragging) MaterialTheme.colorScheme.primaryContainer
                        else MaterialTheme.colorScheme.surfaceVariant
                    )

                    ElevatedCard(
                        elevation = CardDefaults.cardElevation(
                            defaultElevation = elevation.value,
                            pressedElevation = elevation.value,
                            focusedElevation = elevation.value,
                            hoveredElevation = elevation.value,
                            draggedElevation = elevation.value,
                            disabledElevation = elevation.value
                        ),
                        colors = CardDefaults.cardColors(color.value)
                    ) {
                        Item(item, reorderState = reorderState)
                    }
                }
            }
        }
    }
}

@Composable
fun AppDetailScope.Item(
    item: AppDetailScope.WrapperDefinition.OfAppGroup.Apps.Item,
    reorderState: ReorderableLazyListState
) {
    Row(
        Modifier.fillMaxWidth()
            .height(52.dp)
    ) {
        Row(
            modifier = Modifier.weight(1F)
                .fillMaxHeight()
                .clickable {
                    nav.navTo_AppDetailUI(
                        AppDetailArgs(
                            companyId = args.companyId,
                            appId = item.data.id
                        )
                    )
                },
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Box(
                Modifier.size(48.dp)
                    .detectReorder(reorderState)
            ) {
                if (item.enabled.state) {
                    Text(
                        text = "${item.position.state + 1}",
                        style = MaterialTheme.typography.headlineMedium,
                        textAlign = TextAlign.Center,
                        modifier = Modifier.align(Alignment.Center)
                    )
                }
            }
            LazyImage(item.data.logo, Modifier.size(48.dp), alphaBackground = false)
            Text(
                text = item.data.name,
                modifier = Modifier.weight(1F).align(Alignment.CenterVertically),
                maxLines = 2,
                style = MaterialTheme.typography.bodySmall,
                overflow = TextOverflow.Ellipsis
            )
            Space(0.dp)
        }

        VerticalDivider(
            modifier = Modifier.height(32.dp)
                .align(Alignment.CenterVertically),
            color = Color.Gray
        )
        Box(Modifier.fillMaxHeight()
            .clickable { item.enabled.set(!item.enabled.state) }) {
            IconicSwitch(
                checked = item.enabled.state,
                modifier = Modifier.align(Alignment.Center)
                    .padding(horizontal = 8.dp),
                onCheckedChange = { item.enabled.set(it) })
        }
    }
}
